import React from "react";

export const BrandLogo = ({ variant = "mark", className = "h-10" }) => (
  <img
    src={variant === "full" ? "/branding/logo-full.png" : "/branding/logo-mark.png"}
    alt="Link & Rent — Comparez, Réservez, Roulez"
    className={`${className} w-auto object-contain select-none`}
    draggable={false}
  />
);
